import Vue from 'vue'

import {BootstrapVue, BootstrapVueIcons, SpinnerPlugin} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(SpinnerPlugin)
